import jwtDecode from "jwt-decode";
import { match, Pattern } from "ts-pattern";
import { createOidcAuth, SignInType } from "vue-oidc-client/vue3";

import { authConfig } from "./core/config";

const appUrl = `${window.location.origin}/`;

const oidcAuth = createOidcAuth("main", SignInType.Window, appUrl, {
  authority: authConfig.VITE_APP_OIDC_AUTHORITY,
  client_id: authConfig.VITE_APP_OIDC_CLIENT_ID,
  response_type: "code",
  scope: "openid email profile acrevis",
  loadUserInfo: true,
  redirect_uri: `${appUrl}auth/signinwin`,
  silent_redirect_uri: `${appUrl}auth/signinsilent`,
  post_logout_redirect_uri: appUrl,
  automaticSilentRenew: true,
});

oidcAuth.startSilentRenew();

export default oidcAuth;

const VITE_APP_OIDC_CLIENT_ID: string | null = authConfig.VITE_APP_OIDC_CLIENT_ID
  ? authConfig.VITE_APP_OIDC_CLIENT_ID
  : null;

const VITE_APP_OIDC_ROLE_NAMESPACE: string | null = authConfig.VITE_APP_OIDC_ROLE_NAMESPACE
  ? authConfig.VITE_APP_OIDC_ROLE_NAMESPACE
  : VITE_APP_OIDC_CLIENT_ID;

function resourceAccess(): null | Record<string, { roles: string[] }> {
  if (!VITE_APP_OIDC_ROLE_NAMESPACE) return null;
  if (!oidcAuth.isAuthenticated) return null;

  const token: Record<string, never> & { resource_access: Record<string, { roles: string[] }> } = jwtDecode(
    oidcAuth.accessToken,
  );

  return match(token)
    .with({ resource_access: Pattern.select() }, (resource_access) => resource_access)
    .with(Pattern._, () => null)
    .exhaustive();
}

export function roles(): string[] {
  if (!VITE_APP_OIDC_ROLE_NAMESPACE) return [];
  if (!oidcAuth.isAuthenticated) return [];
  const resourceAccessDefinition = resourceAccess();

  return match(resourceAccessDefinition)
    .with({ [VITE_APP_OIDC_ROLE_NAMESPACE]: { roles: Pattern.select("roles") } }, ({ roles }) => roles)
    .with(Pattern._, () => [])
    .exhaustive();
}

export enum ResourceAccessUserRole {
  CONSULTANT = "bdb-consultant",
  ADMIN = "bdb-admin",
}

export function isConsultant() {
  return roles().includes(ResourceAccessUserRole.CONSULTANT);
}

export function isAdmin() {
  return roles().includes(ResourceAccessUserRole.ADMIN);
}

export function canAccessApplication() {
  return isConsultant() || isAdmin();
}

export function employeeAbbreviation() {
  return oidcAuth.userProfile.finnova_username as string;
}
